
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`De manière générale, les aérosols ne mesurent que quelques millièmes de millimètre (micromètres). Du fait de leur petite taille, ils flottent dans l'air pendant des heures et se propagent rapidement, même dans les grandes pièces. Michael Riediker, hygiéniste du travail et expert en évaluation de risques, a modélisé le risque d'infection par le biais d'aérosols pour le  nouveau coronavirus SARS-CoV-2. Sa conclusion: seuls 10% des personnes infectées portent suffisamment de virus en elles pour le transmettre de cette manière. Or, avec le variant Delta, les personnes portent désormais une charge virale beaucoup plus élevée. Ainsi, près d’une personne infectée sur deux peut en infecter d’autres par le biais d’aérosols, selon les circonstances, explique Michael Riediker dans une interview.`}</p>
    <p>{`Fondateur et directeur du Centre suisse de santé au travail et de l’environnement (SCOEH), basé à Winterthour (ZH), il a publié son modèle dans la revue scientifique «JAMA Network Open». Dans un autre article, il a décrit la manière dont ce modèle peut être utilisé afin de simuler différentes situations d'infection. Notre outil est basé sur ces données et a été adapté au variant Delta, ultracontagieux, avec l’aide de Michael Riediker. `}</p>
    <p><strong parentName="p">{`IMPORTANT:`}</strong>{` L'outil simule uniquement le risque d'infection par les aérosols lorsque la distance minimale d'un mètre cinquante est respectée.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;